import React from "react";

import {ReactComponent as FilledRadioCircle} from 'assets/img/filledRadioCircle.svg';
import {ReactComponent as EmptyRadioCircle} from 'assets/img/emptyRadioCircle.svg';

export interface IRadioCircleSvgProps {
  state?: boolean;
  onClick?: (state: boolean) => void;

  radioSelectedIcon?: any;
  radioNotSelectedIcon?: any;

}

const RadioCircleSvg = (props: IRadioCircleSvgProps) => props.state === true ?
  <props.radioSelectedIcon onClick={() => props.onClick(false)}/> :
  <props.radioNotSelectedIcon onClick={() => props.onClick(true)}/>;

RadioCircleSvg.defaultProps = {
  state: false,
  onClick: (state: boolean) => {
  },
  radioSelectedIcon: FilledRadioCircle,
  radioNotSelectedIcon: EmptyRadioCircle,
};
export default RadioCircleSvg;
